import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';

import template from 'url-template';

import queryString from 'query-string';

import ErpAgentInformationPanel from './ErpAgentInformationPanel';
import ErpAgentActionsPanel from '../../components/ErpAgentActionsPanel';
import ERPAgentsPanel from './ERPAgentsPanel';
import EsmsBreadcrumb from '../../components/EsmsBreadcrumb';

import DeleteErpAgentModal from '../Modals/DeleteErpAgentModal';
import RenameErpAgentModal from '../Modals/RenameErpAgentModal';
import RotateCredentialsModal from '../Modals/RotateCredentialsModal';

import * as ErpAgentActions from '../../actions/erpAgentActions';

import classes from './ManageErpAgentPage.module.css';

const ErpAgentsUrl = template.parse('/iothub/erpagents{?company}');

const ManageErpAgentPage = ({
    companyInfo,
    erpAgents,
    fetchErpAgent,
    fetchErpAgents,
    history,
    location,
    selectedAgent,
    setAgent,
    syncErpAgentData
}) => {
    const queryValues = queryString.parse(history.location.search);
    const agentId = queryValues.erpAgent;

    useEffect(() => {
        async function init() {
            if (!selectedAgent.id) {
                if (!agentId) {
                    history.push(ErpAgentsUrl.expand({
                        company: queryValues.company
                    }));
                    return;
                }
                await fetchErpAgent(agentId);
            }
        }

        init();
    }, []);

    useEffect(() => {
        if (erpAgents && erpAgents.length && !selectedAgent.id) {
            const selectedErpAgent = erpAgents.find(agent => agent.id === agentId);
            if (selectedErpAgent) {
                setAgent(selectedErpAgent);
            }
        }
    }, [erpAgents, selectedAgent]);

    const [deleteErpAgentModalOpen, setDeleteErpAgentModalOpen] = useState(false);
    const [renameErpAgentModalOpen, setRenameErpAgentModalOpen] = useState(false);
    const [rotateCredentialsModalOpen, setRotateCredentialsOpen] = useState(false);

    const handleToggleDeleteErpAgentModal = toggleState => {
        setDeleteErpAgentModalOpen(toggleState);
    };

    const handleToggleRenameErpAgentModal = toggleState => {
        setRenameErpAgentModalOpen(toggleState);
    };

    const handleToggleRotateCredentialsModal = toggleState => {
        setRotateCredentialsOpen(toggleState);
    };

    const handleIotHubRoute = () => {
        history.push(`/iothub?company=${queryValues.company}`);
    };

    const handleErpAgentsRoute = () => {
        history.push(`/iothub/erpagents?company=${queryValues.company}`);
    };

    if (!selectedAgent) return null;

    return (
        <React.Fragment>
            <header>
                <EsmsBreadcrumb
                    parents={[companyInfo.companyName, 'FSM Integrations']}
                    child={selectedAgent.name}
                    handlers={[handleIotHubRoute, handleErpAgentsRoute]}
                />
            </header>
            <div className={classes.ManageErpAgentPage} >
                <aside className={classes.sidebar}>
                    <ErpAgentInformationPanel agent={selectedAgent} companyInfo={companyInfo} />
                    <ErpAgentActionsPanel
                        companyInfo={companyInfo}
                        history={history}
                        agent={selectedAgent}
                        toggleDeleteErpAgentModal={handleToggleDeleteErpAgentModal}
                        toggleRenameErpAgentModal={handleToggleRenameErpAgentModal}
                        toggleRotateCredentialsModal={handleToggleRotateCredentialsModal}
                        syncErpAgentData={syncErpAgentData}
                    />
                </aside>
                <ERPAgentsPanel
                    history={history}
                    location={location}
                    selectedAgent={selectedAgent}
                />
            </div>
            <DeleteErpAgentModal
                open={deleteErpAgentModalOpen}
                close={() => handleToggleDeleteErpAgentModal(false)}
                title={`Delete Integration Configuration: ${selectedAgent.name}`}
            />
            <RenameErpAgentModal
                agent={selectedAgent}
                open={renameErpAgentModalOpen}
                close={() => handleToggleRenameErpAgentModal(false)}
                title={`Rename Agent: ${selectedAgent.name}`}
            />
            <RotateCredentialsModal
                agent={selectedAgent}
                isOpen={rotateCredentialsModalOpen}
                handleClose={() => handleToggleRotateCredentialsModal(false)}
            />
        </React.Fragment>
    );
};

const mapStateToProps = ({ erpAgent, ...state }) => {
    const { erpAgents, selectedAgent } = erpAgent;

    return {
        companyInfo:   state.companyInfo,
        currentScopes: state.core.currentScopes,
        devices:       state.device.devices,
        erpAgents:     Object.values(erpAgents),
        selectedAgent
    };
};

const mapDispatchToProps = {
    ...ErpAgentActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ManageErpAgentPage));
